import React, {useMemo} from 'react';
import {Route, Routes} from "react-router-dom";
import {buildHotspotExplorerIndex} from "./helpers";
import {endPerfTimer, startPerfTimer} from "../../helpers/perf";
import type {HotspotExplorerProps} from "./types";
import {AllHotspotsView} from "./all-hotspots";
import {CountryHotspotsView} from "./country";
import {CountyHotspotsView} from "./county";
import {HotspotDetailView} from "./hotspot-detail";
import {StateHotspotsView} from "./state";

export default function HotspotExplorer(props: HotspotExplorerProps) {
    const hotspotExplorerIndex = useMemo(() => {
        const timer = startPerfTimer('hotspotExplorer:buildIndex');
        const result = buildHotspotExplorerIndex(props.observationsByLocation);
        endPerfTimer(timer);
        return result;
    }, [props.observationsByLocation]);
    const routeProps = useMemo(() => ({
        ...props,
        hotspotExplorerIndex
    }), [hotspotExplorerIndex, props]);
    const routeTree = useMemo(() => {
        return (
            <Routes>
                <Route path="/hotspot-explorer" element={<AllHotspotsView {...routeProps} />} />
                <Route path="/hotspot-explorer/list/:countryCode" element={<CountryHotspotsView {...routeProps} />} />
                <Route path="/hotspot-explorer/list/:countryCode/:stateProvince" element={<StateHotspotsView {...routeProps} />} />
                <Route path="/hotspot-explorer/list/:countryCode/:stateProvince/:county" element={<CountyHotspotsView {...routeProps} />} />
                <Route path="/hotspot-explorer/hotspot/:locationId" element={<HotspotDetailView {...routeProps} />} />
            </Routes>
        );
    }, [routeProps]);

    return routeTree;
}
